import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'td-wb-card-header',
  templateUrl: 'card-header.component.html',
  styleUrls: ['card-header.component.scss'],
  host: {
    '[class.td-wb-card-header--background]': 'background()',
    '[class.td-wb-card-header__divider]': 'divider()'
  }
})
export class CardHeaderComponent {

  background: InputSignal<boolean> = input(false);
  divider: InputSignal<boolean> = input(false);

}
